<template lang="pug">
.unistar-table-container
  .unistar-basic-info
    .unistar-basic-info-col
      .star_info
        span {{ starData.star_name }}
        el-button(
          style="margin-left: 30px"
          type="text"
          v-if="canEdit"
          @click="$emit('edit', index)"
        ) {{ $t('修改') }}
      .date(v-if="starData.star_offer_date") {{ $t('合作期限') }}：{{ starData.star_offer_date.start_date | formatDate }} - {{ starData.star_offer_date.end_date | formatDate }}   
    .unistar-basic-info-col
      span(v-if="starData.star_offer_price.tax_total_price") {{ starData.star_offer_price.tax_total_price | formatMoney }}
      el-button(
        type="text"
        @click="isFold = !isFold"
        :disabled="!starData.star_offer_price.tax_total_price"
      ) {{ isFold ? $t('查看明细') : $t('收起') }}
  .unistar-quotation-info(v-if="!isFold")
    unistar-tables(
      :starData="starData"
    )
</template>

<script>
import { formatMoney, numMulti, formatDate } from '@/umcc/util'
import UnistarTables from '../UnistarTables'
export default {
  props: {
    starData: {
      type: Object,
      default () {
        return {}
      }
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isFold: true,
      visible: false
    }
  },
  components: {
    UnistarTables
  },
  filters: {
    formatMoney,
    formatDate
  },
  methods: {
    numMulti
  }
}
</script>

<style lang="stylus">
.unistar-table-container
  margin-bottom 20px
  min-width 900px
  max-width 1080px
  border-radius 4px
  border solid 1px #e9e9e9
  box-shadow 0 2px 8px 0 rgba(0, 0, 0, 0.05)
  box-sizing border-box
  .unistar-basic-info
    height 73px
    padding 0 24px
    display flex
    justify-content space-between
    align-items center
    .unistar-basic-info-col
      font-size 18px
      font-weight bold
      .date
        font-size: 12px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #888888;
        margin-top: 5px
      .el-button
        margin-left 180px
  .unistar-quotation-info
    padding 24px
    border-top solid 1px #e9e9e9
</style>
